import listReducer from './list/reducer';

export default {
  memberList: listReducer,
};
